// extracted by mini-css-extract-plugin
export default {"trendStartCardPanel":"TrendStatCardPanel_trendStartCardPanel__+0hDq","trendStatCardPanel":"TrendStatCardPanel_trendStatCardPanel__rQSiy"};